import Collapse from '@material-ui/core/Collapse';
import MenuList from '@material-ui/core/MenuList';
import ITIcon from '@material-ui/icons/Computer';
import UsersIcon from '@material-ui/icons/PersonOutline';
import DisplaysIcon from '@material-ui/icons/Visibility';
import * as React from 'react';
import { HasPermissions } from '../../components/HasPermissions';
import { LeftNavHeader } from '../../components/LeftNavHeader';
import { NavTypes, NavUrls } from '../layoutConstants';
import { MenuLink } from '../MenuLink';

interface IInfoTechMenuProps {
  collapsed: boolean;
  menuClassName: string;
  navType: NavTypes;
  onExpandClick: (navType: NavTypes) => any;
  onNavClick: () => any;
  currentLocation: string;
}

let InfoTechMenu: React.FunctionComponent<IInfoTechMenuProps> = ({
  collapsed,
  menuClassName,
  onExpandClick,
  onNavClick,
  navType,
  currentLocation
}) => {
  React.useEffect(() => {
    if (currentLocation.includes('it') || currentLocation.includes('permissions/users')) {
      onExpandClick('it');
    }
  }, []);

  return (
    <HasPermissions type="it">
      <LeftNavHeader collapsed={collapsed} navType={navType} onExpandClick={onExpandClick} icon={ITIcon} title="IT" />
      <Collapse component="li" in={collapsed} timeout="auto" unmountOnExit>
        <MenuList disablePadding>
          <MenuLink
            icon={<DisplaysIcon />}
            to={NavUrls.itDisplays}
            label="Displays"
            menuClassName={menuClassName}
            onNavClick={onNavClick}
            isActive={currentLocation === NavUrls.itDisplays}
          />
          <MenuLink
            icon={<UsersIcon />}
            to={NavUrls.itPermissions}
            label="Permissions"
            menuClassName={menuClassName}
            onNavClick={onNavClick}
            isActive={currentLocation === NavUrls.itPermissions}
          />
        </MenuList>
      </Collapse>
    </HasPermissions>
  );
};

InfoTechMenu = React.memo<IInfoTechMenuProps>(InfoTechMenu);
export { InfoTechMenu };
